module.exports = __webpack_public_path__ + "static/10-insights-25b33ed14395b8f99ec9da58e8bfbca8.jpg";